/* FAQ アコーディオン */
/*===========================*/
document.addEventListener('DOMContentLoaded', function(){
    let mm = gsap.matchMedia();
    mm.add("(max-width: 743px)", () => {

    let toggleButton2 = document.querySelectorAll('.accordion__item-head2');
    for (let i = 0; i < toggleButton2.length; i++) {
        toggleButton2[i].addEventListener('click',function(){
            let target = this.nextElementSibling;
            let target2 = this;
            const result = target.classList.contains('is-active');
            const question = target2.classList.contains('is-active');
            
            if (result) {
                // 閉じる
                target.classList.remove('is-active');
                
                gsap.to(target,{
                    height: 0,
                    duration:0.5,
                    ease: "power2.inOut",
                    
                });
            }else{
                // 開く
                target.classList.add('is-active');
                gsap.to(target,{
                    height:'auto',
                    duration:0.5,
                    ease: "power2.inOut",
                    
                });
            }

            if (question) {
                // 閉じる
                target2.classList.remove('is-active');
            }else{
                // 開く
                target2.classList.add('is-active');
            }
            
        })
        
    }

});
}, false);